<div class="main-container full-size p-2">
  <!-- Tabs -->
  <ul class="nav nav-pills nav-fill">
    <li class="nav-item">
      <a [class.active]="activeTab===0" (click)="activeTab=0" class="nav-link" href="javascript:;">Sign in</a>
    </li>
    <li class="nav-item">
      <a [class.active]="activeTab===1" (click)="activeTab=1" class="nav-link" href="javascript:;">Sign up</a>
    </li>
  </ul>

  <!-- Space -->
  <hr>

  <!-- Sign in -->
  <app-login-view [hidden]="activeTab!==0" (loginSuccess)="loginSuccess($event)"></app-login-view>

  <!-- Register -->
  <app-register-view [hidden]="activeTab!==1" (registerSuccess)="registerSuccess()"></app-register-view>
</div>